import React from "react";
import { useGlobal } from "@/context/GlobalContext";
import { isDevToolsEnabled } from "@/utils/devTools";

/**
 * Floating toggle button — gated behind `?dev=true` (see utils/devTools).
 * Enables God Mode which bypasses profile-completion guards,
 * unlocking all sidebar pages and panels for inspection.
 */
const GodModeToggle: React.FC = () => {
    const { godMode, setGodMode } = useGlobal();

    if (!isDevToolsEnabled()) return null;

    return (
        <button
            onClick={() => setGodMode(!godMode)}
            title={
                godMode
                    ? "God Mode ON – all pages & panels unlocked. Click to disable."
                    : "God Mode OFF – click to unlock all pages & panels."
            }
            style={{
                position: "fixed",
                bottom: "1.25rem",
                right: "1.25rem",
                zIndex: 9999,
                padding: "0.45rem 0.9rem",
                borderRadius: "9999px",
                border: "2px solid",
                fontWeight: 700,
                fontSize: "0.7rem",
                letterSpacing: "0.07em",
                cursor: "pointer",
                boxShadow: "0 4px 14px rgba(0,0,0,0.4)",
                transition: "background 0.2s, color 0.2s, border-color 0.2s",
                background: godMode ? "#facc15" : "#1e293b",
                borderColor: godMode ? "#ca8a04" : "#475569",
                color: godMode ? "#1e293b" : "#64748b",
                userSelect: "none",
            }}
        >
            {godMode ? "⚡ GOD MODE ON" : "☁ GOD MODE"}
        </button>
    );
};

export default GodModeToggle;
